import React from "react";
import {Row} from "../form/Form/Form";
import * as TextField from "../form/TextField/TextField";
import * as ColorPicker from "../form/ColorPickerField/ColorPickerField";
import {BaseEntity} from "../../api/entities/BaseEntity";
import "./entities-list-row-form.scss";
import Tooltip from "@mui/material/Tooltip";


const EntityListRowForm = <T extends BaseEntity & { color?: string; departures?: number; }>({
                                                                                                entity: {
                                                                                                    id,
                                                                                                    name,
                                                                                                    color,
                                                                                                    departures
                                                                                                }
                                                                                            }: {
    entity: T
}) => {
    return (
        <Row>
            {
                color
                    ? <div style={{minWidth: '32px', flexGrow: 0}}>
                        <ColorPicker.default
                            name="color"
                            value={color}
                            linkable
                        />
                    </div>
                    : null
            }
            <TextField.default
                name="name"
                type="text"
                value={name ?? id}
                style={{minWidth: '80px'}}
                linkable
            />
            {
                departures
                    ? <Tooltip title="departures" placement="top" disableInteractive>
                        <div className="entities-list-row__departures">{departures}</div>
                    </Tooltip>
                    : null
            }
        </Row>
    );
}

export default EntityListRowForm;